import React from 'react';

function stripSurroundingUrlPunctuation(value: string) {
  let v = value.trim();
  if (!v) return v;

  // Remove caracteres comuns que vêm junto ao copiar/colar URLs em textos
  // Ex.: "(https://site.com),", "https://site.com.", "\"https://site.com\""
  v = v.replace(/^[("'[\s]+/, '');
  v = v.replace(/[)"'\],.;:\s]+$/, '');

  // Caso venha em cascata, aplica novamente de forma segura
  v = v.replace(/^[("'[\s]+/, '');
  v = v.replace(/[)"'\],.;:\s]+$/, '');

  return v;
}

export const normalizeUrlWhenPaste = (
  e: React.ClipboardEvent<HTMLInputElement>,
) => {
  e.preventDefault();
  let pasted = e.clipboardData.getData('text').trim().replace(/\s/g, '');
  pasted = stripSurroundingUrlPunctuation(pasted);

  pasted = pasted.replace(/^(https?:\/\/)+/g, '');

  pasted = stripSurroundingUrlPunctuation(pasted);

  const finalValue = pasted ? `https://${pasted}` : '';
  (e.target as HTMLInputElement).value = finalValue;

  return finalValue;
};

export const normalizeUrlOnBlur = (value: string): string => {
  let normalizedValue = stripSurroundingUrlPunctuation(value);

  if (!normalizedValue) return '';

  if (normalizedValue.startsWith('http://')) {
    normalizedValue = normalizedValue.replace('http://', 'https://');
  }

  if (
    !normalizedValue.startsWith('https://') &&
    !normalizedValue.startsWith('http://')
  ) {
    normalizedValue = `https://${normalizedValue}`;
  }

  return stripSurroundingUrlPunctuation(normalizedValue);
};

export const isValidHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const isCompleteHttpUrl = (value: string): boolean => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return false;
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    return Boolean(url.hostname);
  } catch {
    return false;
  }
};
